import { GetServerSideProps } from "next";
import api from "../../lib/utils/api";
import { mapOurExpertsPageData } from "../../lib/utils/mappers";
import { Locale } from "../../lib/types";
import { Card, Col, Container, Row } from "react-bootstrap";
import parse from 'html-react-parser';
import styles from '../../styles/OurExperts.module.css'
import { RichText } from "../../components/RichText";
import Featurette from "../../components/Featurette";
import { FEATURETTE_IMAGE_PLACEMENTS } from "../../lib/constants";
import cmsEndpoints from "../../lib/utils/cmsEndpoints";
import { PageHead } from "../../components/PageHead";

export const getServerSideProps: GetServerSideProps = async (context) => {

  const locale = context.locale as Locale

  const pageData = await api.get(cmsEndpoints.ourExpertsPage())

  const page = mapOurExpertsPageData(pageData?.data?.data?.attributes, locale)

  return {
    props: {
      page
    }
  }
}

const OurExperts = (props: any) => {

  return (
    <>
      <PageHead title={props.page?.title} image={props.page?.image} />
      <Featurette image={props.page.image && props.page.image} imagePlacement={FEATURETTE_IMAGE_PLACEMENTS.RIGHT} backgroundColor='#F8FBFC' mobileFullscreenImage={true}>
        {props.page?.title && <h1 className="mb-2"> {props.page?.title} </h1>}
        {props.page?.description && <RichText content={props.page?.description} />}
      </Featurette>
      <Container>
        {props.page?.benefits &&
          <Row className="py-5 mb-5">
            {props.page?.benefits?.map((benefit: any, index: number) => (
              <Col md='6' lg='3' className='text-center' key={index}>
                {benefit?.icon && <><img className='mb-2' srcSet={`${benefit?.icon} 2x`} alt='' /><br /></>}
                {benefit?.title && <h5 className="mb-2"> {benefit?.title} </h5>}
                {benefit?.description && <div className="text-muted caption max-line-4 mb-4 mb-lg-0"> {benefit?.description} </div>}
              </Col>
            ))}
          </Row>
        }
        {props.page?.experts &&
          <div className="py-5">

            <Row className="mb-3 h-100 justify-content-center">
              <Col className="text-center mb-5" md="8" >
                {props.page?.expertsTitle && <h2 className="mb-2"> {props.page?.expertsTitle} </h2>}
                {props.page?.expertsDescription && <div className="text-muted"> {props.page?.expertsDescription} </div>}

              </Col>
            </Row>
            <Row>
              {props.page?.experts?.map((expert: any, index: number) => (
                <Col className="mb-3" lg="6" key={index}>
                  <Card className="h-100 bg-gray-1">
                    <Row className="align-items-end mb-3">
                      <Col xs="9">
                        {expert?.name && <h5> {expert?.name} </h5>}
                        {expert?.profession && <div> {expert?.profession} </div>}
                      </Col>
                      {expert?.avatar &&
                        <Col>
                          <div className={styles.avatarContainer}>
                            <img className={`${styles.avatar} img-fluid rounded`} src={expert?.avatar} alt='avatar' />
                          </div>
                        </Col>
                      }
                    </Row>
                    {expert?.bio && <div className="text-muted caption"> {parse(expert?.bio)} </div>}
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        }

        <div className="py-5">
          <Row className="mb-3 h-100 justify-content-center">
            <Col className="text-center mb-5" md="8" >
              {props.page?.referencesTitle && <h2 className="mb-2"> {props.page?.referencesTitle} </h2>}
              {props.page?.referencesDescription && <div className="text-muted"> {props.page?.referencesDescription} </div>}
            </Col>
          </Row>

          <Row>
            <Col className="mb-5" xs="12" >

              {props.page?.references && <RichText className="text-muted" content={props.page?.references} />}
            </Col>
          </Row>
        </div>
      </Container>
    </>
  )
}

export default OurExperts
